
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 81 54"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#4189DD","d":"M0 0h81v54H0z"}}),_c('g',{attrs:{"transform":"matrix(13 0 0 13 40.5 27)"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","fill":"#FFF","transform":"rotate(18 3.157 -.5)","d":"M0 0v1h.5z"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-144)"}})])])
          )
        }
      }
    